module.exports = __webpack_public_path__ + "assets/img/sweep-project.43185aa4.webp";